import { Button, Dialog, } from "@mui/material";
import { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import { updateReturnLocation } from "../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";

type UpdateLocationModalProps = {
    updateLocationIsOpen: boolean;
    setUpdateLocationIsOpen: (Value: boolean) => void;
    locationOptions: any[];
    summaryData: any;
    selectedVehicleClass: any;
    isCompletedOrCancelled: boolean;
    refreshTheSummary: () => void;
    reservationId: number;
    setPleaseWaitPopup: (value: boolean) => void;
}

const UpdateLocationModal = ({
    updateLocationIsOpen,
    setUpdateLocationIsOpen,
    locationOptions,
    summaryData,
    selectedVehicleClass,
    isCompletedOrCancelled,
    refreshTheSummary,
    reservationId,
    setPleaseWaitPopup
}: UpdateLocationModalProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const [returnLocations, setReturnLocations] = useState<number>(0);
    const [locationAlert, setLoactaionAlert] = useState<string>("");

    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (returnLocations > 0) {
            setLoactaionAlert("");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [returnLocations])


    const handleSubmit = async () => {
        if (!isCompletedOrCancelled) {
            if (selectedVehicleClass?.additionalChargeIdforReturnInDifferentLocation > 0) {
                if (returnLocations > 0) {
                    if (returnLocations !== summaryData?.returenLoationId) {
                        setPleaseWaitPopup(true);

                        updateReturnLocation(
                            returnLocations,
                            reservationId,
                            auth?.id,
                            tenantId
                        )
                            .then(() => {
                                refreshTheSummary();
                                setUpdateLocationIsOpen(false);
                                resetTheForm();
                                handleTenantError(null);
                            })
                            .catch(error => {
                                setPleaseWaitPopup(false);
                                handleTenantError(error);
                            });
                    } else {
                        setLoactaionAlert("You are already returning the vehicle on this location!");
                    }
                } else {
                    setLoactaionAlert("Please select a loaction!");
                }
            } else {
                setLoactaionAlert("This vehicle class does not have any update location charge!");
            }
        }
    }

    const resetTheForm = () => {
        setReturnLocations(0);
        setLoactaionAlert("");
    }

    return (
        <>
            <Dialog
                open={updateLocationIsOpen}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setUpdateLocationIsOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Update Location</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <div>
                                                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Return Location</label>
                                                <select
                                                    className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    value={returnLocations}
                                                    onChange={(e) => setReturnLocations(parseInt(e.target.value))}
                                                    required
                                                >
                                                    <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>{"None"}</option>
                                                    {
                                                        locationOptions
                                                            ?.filter((item: any) => item?.id !== summaryData?.returenLoationId)
                                                            ?.map((item: any, index: number) => {
                                                                return <option className={`${themeStyles.main.tailwindSectionBg}`} key={index} value={item?.id}>{item?.locationName}</option>
                                                            })
                                                    }
                                                </select>
                                            </div>

                                            {
                                                locationAlert && (
                                                    <span className="w-full text-sm text-red-500">{locationAlert}</span>
                                                )
                                            }

                                            <div className="mt-4 w-full flex gap-4">
                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.main.bg
                                                    }}
                                                    onClick={handleSubmit}
                                                >
                                                    Save
                                                </Button>

                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => setUpdateLocationIsOpen(false)}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default UpdateLocationModal;